import clsx from 'clsx';

/** Iconen uit de Kordaro-sprite (ontwerp/iconen + Store-aanvulling in dezelfde familie). */
export type KIconNaam =
  | 'vandaag' | 'gesprekken' | 'dossiers' | 'planning' | 'team' | 'winkel' | 'logistiek' | 'scanner'
  | 'laden' | 'lossen' | 'verplaatsen' | 'plaatsing' | 'documenten' | 'fotos' | 'handtekening' | 'finance'
  | 'service' | 'vink' | 'let' | 'fout' | 'info' | 'klok' | 'blokkade' | 'pijl' | 'chevron' | 'plus' | 'zoek'
  | 'sluit' | 'slot' | 'verstuur' | 'bel' | 'plaats' | 'sync' | 'offline' | 'opgeslagen' | 'meer' | 'persoon'
  | 'collo' | 'beslis'
  | 'marketing' | 'catalogus' | 'instellingen' | 'filter' | 'bijlage' | 'download' | 'menu' | 'terug'
  | 'melding' | 'uitloggen' | 'notitie' | 'dashboard';

export const KORDARO_SPRITE = '/brand/kordaro/kordaro-sprite.svg';

/**
 * Decoratief icoon (aria-hidden); het label staat altijd als tekst ernaast of als aria-label op de knop.
 * Grootte 20 standaard (navigatie), 24 voor grote doelen.
 */
export function KIcon({ naam, size = 20, className }: { naam: KIconNaam; size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      className={clsx('k-icon', className)}
      fill="none"
      stroke="currentColor"
      strokeWidth={naam === 'meer' ? 3 : 1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <use href={`${KORDARO_SPRITE}#i-${naam}`} />
    </svg>
  );
}
